import script from "./BoardPostPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoardPostPopup.vue?vue&type=script&setup=true&lang=ts"

import "./BoardPostPopup.vue?vue&type=style&index=0&id=8859ba92&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8859ba92"]])

export default __exports__